import { render, staticRenderFns } from "./VendorInvite.vue?vue&type=template&id=4f30e398"
import script from "./VendorInvite.vue?vue&type=script&lang=js"
export * from "./VendorInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports